import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { ButtonsModule } from '@components/buttons/buttons.module';
import { ProfileCardModule } from '@components/profile-card/profile-card.module';
import { SearchModule } from '@components/search/search.module';
import { AnalysisFinishModule } from '@modules/analysis/components/analysis-finish/analysis-finish.module';
import { SidebarModule } from '../sidebar/sidebar.module';
import { HeaderComponent } from './header.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SearchModule,
    ProfileCardModule,
    ButtonsModule,
    SidebarModule,
    AnalysisFinishModule,
    MatDialogModule,
  ],
  exports: [HeaderComponent],
  declarations: [HeaderComponent],
})
export class HeaderModule {}
